// extracted by mini-css-extract-plugin
export default {"gallery":"BikesGallerySection_gallery__K5NQO","header":"BikesGallerySection_header__BiMfh","button":"BikesGallerySection_button__f-7QX"};